import { JSX } from "react/jsx-runtime"

import { THEME } from "@/3514/theme"

import IntrinsicElements = JSX.IntrinsicElements

function getEditorInsertableClasses(identifier: string): string {
    return `
        .${identifier} * { 
          color: ${THEME.COLORS.gray[100]};
          font-weight: ${THEME.FONT_WEIGHTS[300]};
          line-height: ${THEME.LINE_HEIGHTS[21]}px;
          font-size: ${THEME.FONT_SIZES[14]}px;
          text-wrap: pretty;
          text-align: center;
          hyphens: auto;
          
          @media screen and (min-width: 992px) {
            text-align: left;
          }
        }
        .${identifier} strong { font-weight: ${THEME.FONT_WEIGHTS[800]}; }
        .${identifier} p, 
        .${identifier} ul { margin-bottom: 0px; }
        .${identifier} ul { line-height: ${THEME.LINE_HEIGHTS[24]}px; list-style-position: inside; list-style-type: disc; }
        .${identifier} a { 
          color: ${THEME.COLORS.accent}; 
        }
        .${identifier} a:hover, .${identifier} a:focus { 
          text-underline-offset: 5px;
          outline: none;
        }
    `
}

const editorAllowedTags: (keyof IntrinsicElements)[] = [
    "p",
    "span",
    "strong",
    "a",
    "b",
    "u",
    "i",
    "em",
    "ul",
    "ol",
    "li",
    "br"
]

const uiConfig = {
    getEditorInsertableClasses,
    editorAllowedTags
}

export { uiConfig as coachInfoConfig }
